import {ButtonWrapper} from "./_Button";
import {useEditorRef, useEditorSelector} from "platejs/react";
import FontAwesome from "../../../utilities/FontAwesome";

export function RedoButton(props) {

    const editor = useEditorRef();
    const disabled = useEditorSelector(
        (editor) => editor.history.redos.length === 0,
        []
    );

    return <ButtonWrapper
        disabled={disabled}
        onClick={() => editor.redo()}
        onMouseDown={(e) => e.preventDefault()}
        tooltip={"Redo"}
    >
        <FontAwesome prefix={"fas"} name={"fa-rotate-right"} fixedWidth />
    </ButtonWrapper>
}

export function UndoButton(props) {
    const editor = useEditorRef();
    const disabled = useEditorSelector(
        (editor) => editor.history.undos.length === 0,
        []
    );

    return <ButtonWrapper
        disabled={disabled}
        onClick={() => editor.undo()}
        onMouseDown={(e) => e.preventDefault()}
        tooltip={"Undo"}
    >
        <FontAwesome prefix={"fas"} name={"fa-rotate-left"} fixedWidth />
    </ButtonWrapper>
}
